module.exports = __webpack_public_path__ + "static/media/IMG_20181114_212343.e1b1d826.jpg";